import { sanitizeMarkup } from "../helper/sanitize";
import Message from "./message";

class MessageFactory {
    constructor(
        private replyMessageTemplate: HTMLTemplateElement,
        private userMessageTemplate: HTMLTemplateElement
    ) {
    }

    public create(message: string, isReply: boolean = false, id?: string, data: MessageData = {}): MessageInterface {
        const template = isReply ? this.replyMessageTemplate : this.userMessageTemplate;
        const sanitizedMessage = sanitizeMarkup(message);
        const messageElement = template.content.firstElementChild?.cloneNode(true) as HTMLElement;
        const messageContentArea = messageElement.querySelector('[data-js-chat-message]') as HTMLElement;

        messageContentArea.innerHTML = sanitizedMessage;
        const messageId = id || `message-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        messageElement.setAttribute('data-js-message-id', messageId);

        return new Message(isReply, messageContentArea, messageElement, messageId, sanitizedMessage, data);
    }
}

export default MessageFactory;